module.exports = __webpack_public_path__ + "img/94020.aea167b4.svg";